<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    皇岗村站<br>
站点介绍<br>
皇岗村站位于水围村北侧，处在福民路与皇岗公园街交叉口，车站沿福民路东西方向布设。 皇岗村站为地下站3层钢筋混凝土结构，属于地下车站，岛式站台，地下1层为站厅层，地下2层为设备层，地下3层为站台层。皇岗村站设A、B1、B2、C1、C2、D、E七个出入口通道。 车站装修以米白色及淡紫色为主色调，以LED环形造型灯具为设计特色，通过色彩变化、灯光效果等处理手法，为乘客提供舒适轻松的乘车环境。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:28	23:27	7号线	3分35秒	5分55秒<br>
太安	06:02	23:30	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:22	23:27	7号线	4分钟	5分55秒<br>
太安	06:08	23:30	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:22	00:27	7号线	4分钟	5分55秒<br>
太安	06:08	00:30	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
福民路南侧（西）、益田路、皇岗新村、皇岗公园、共和世家、高发城驰苑、福乐雅苑<br><br>
B出入口:<br>
福民路南侧（东）、金田路、水围村、皇岗新村、晨辉家园、皇廷彩园<br><br>
C出入口:<br>
福民路北侧（东）、金田路、皇岗村、皇兴大厦<br><br>
D出入口:<br>
福民路北侧（东）、中心花园、皇岗三龙花园、佑民庄<br><br>
E出入口:<br>
福民路北侧（西）、益田路、福田区皇岗小学、锦绣园、皇达东方雅苑<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 皇岗村<br>
34路、63路、73路、202路、303路、385路、B689路、N10路、M133路E出入口<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>